import { ProposalType } from '@/components/Views/SchoolProposalList/schoolProposalList.hook';
import { create } from 'zustand';

type SchoolStore = {
  schoolListPage: number;
  setSchoolListPage: (page: number) => void;
  schoolProposalListPage: number;
  schoolListlimit: number;
  setSchoolListLimit: (listlimit: number) => void;
  schoolProposalListlimit: number;
  setSchoolProposalListLimit: (listlimit: number) => void;
  mode: string;
  isOpenSchoolProposalModal: boolean;
  openSchoolProposalModal: () => void;
  schoolProposal: ProposalType | undefined;
  setSchoolProposal: (proposal: ProposalType) => void;
  setSchoolProposalListPage: (page: number) => void;
  setMode: (mode: string) => void;
};
export const useSchoolStore = create<SchoolStore>()((set) => ({
  schoolListPage: 1,
  schoolProposalListPage: 1,
  schoolListlimit: 10,
  schoolProposalListlimit: 10,
  isOpenSchoolProposalModal: false,
  schoolProposal: undefined,
  mode: 'validate',
  setSchoolListPage: (schoolListPage) => set({ schoolListPage }),
  setSchoolProposalListPage: (schoolProposalListPage) =>
    set({ schoolProposalListPage }),
  setSchoolListLimit: (schoolListlimit) => set({ schoolListlimit }),
  setSchoolProposalListLimit: (schoolProposalListlimit) =>
    set({ schoolProposalListlimit }),
  setMode: (mode) => set({ mode }),
  openSchoolProposalModal: () =>
    set((state) => ({
      isOpenSchoolProposalModal: !state.isOpenSchoolProposalModal,
    })),
  setSchoolProposal: (schoolProposal) => set({ schoolProposal }),
}));
